import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, Text, TextStyle, View } from "react-native";

import colours from "../styles/colours";
import { BorderRadius, Spacing } from "../styles/number";
import { Typography } from "../styles/typography";

export interface OpenClosedProps {
  open: boolean;
  textStyle?: TextStyle;
}

const styles = StyleSheet.create({
  text: {
    color: colours.white,
    lineHeight: 15,
  },
  container: {
    alignItems: "center",
    marginRight: Spacing.Thin,
    padding: Spacing.ExtraThin,
    borderRadius: BorderRadius.Highest,
  },
  open: {
    backgroundColor: colours.green,
  },
  closed: {
    backgroundColor: colours.red,
  },
});

const OpenClosed = ({ open, textStyle }: OpenClosedProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <View style={[styles.container, open ? styles.open : styles.closed]}>
      <Text
        style={[
          Typography.bodyBold,
          styles.text,
          open ? styles.open : styles.closed,
          textStyle ? textStyle : null,
        ]}>
        {open ? t("StoreSearch:OpenStore") : t("StoreSearch:ClosedStore")}
      </Text>
    </View>
  );
};

export default OpenClosed;
